/*
  GD hotspot popups. Any [data-gd-popup="<id>"] opens the .gd-popup with that id; the close
  button, a click on the backdrop or Escape closes it. Delegated, so it works for hotspots added
  later (theme editor reloads) and is safe to load from several sections.
*/
(function () {
  if (window.gdPopupReady) return;
  window.gdPopupReady = true;

  var lastTrigger = null;

  function open(popup, trigger) {
    if (!popup) return;
    // Move the popup to <body> so no transformed or clipped ancestor can trap the fixed overlay.
    if (popup.parentElement !== document.body) document.body.appendChild(popup);
    lastTrigger = trigger || null;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gd-popup-open');
    var close = popup.querySelector('[data-gd-popup-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function close(popup) {
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.gd-popup.is-open')) document.body.classList.remove('gd-popup-open');
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-gd-popup]');
    if (trigger) {
      event.preventDefault();
      open(document.getElementById(trigger.getAttribute('data-gd-popup')), trigger);
      return;
    }
    if (event.target.closest('[data-gd-popup-close]')) {
      event.preventDefault();
      close(event.target.closest('.gd-popup'));
      return;
    }
    if (event.target.classList && event.target.classList.contains('gd-popup')) close(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close(document.querySelector('.gd-popup.is-open'));
  });

  // Theme editor: drop popups moved to <body> when their section re-renders or is removed.
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    document.querySelectorAll('body > .gd-popup[data-section-id="' + sectionId + '"]').forEach(function (popup) {
      popup.remove();
    });
    document.body.classList.remove('gd-popup-open');
  });
})();
